import { connect } from 'react-redux';
import { crearPanel, //    desactivar,
moverPanel, eliminarPanel } from '../actions';
import { getActivas, //    getVisibles,
getPaneles } from '../selectors';
import Mascaras from '../components/mascaras'; // import { seleccionarHerramienta } from '../../actions/barra-herramientas'
// import { PUNTERO_ID, GRUPO_PIZARRA } from '../../herramientas/constantes'

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    activas: getActivas(state),
    visibles: getActivas(state),
    // getVisibles(state),
    paneles: getPaneles(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onCrearPanel: function onCrearPanel(x, y, w, h) {
      return dispatch(crearPanel(x, y, w, h));
    },
    onMoverPanel: function onMoverPanel(id, x, y, w, h) {
      return dispatch(moverPanel(id, x, y, w, h));
    },
    onEliminarPanel: function onEliminarPanel(id) {
      return dispatch(eliminarPanel(id));
    }
  };
};

var MascarasContainer = connect(mapStateToProps, mapDispatchToProps)(Mascaras);
export default MascarasContainer;